import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { addAllList } from 'modules/common';

import FilterCollection from 'components/organisms/FilterCollection';

const NewExternalFilter = (props) => {
  const {
    params,
    handleGetParams = (f) => f,
    name,
    type,
    externalList = undefined,
  } = props;

  const { t } = useTranslation();

  const { externalCodeList } = useSelector(({ common }) => ({
    externalCodeList: common.externalCodeList,
  }));

  const [list, setList] = useState([...externalCodeList]);

  useEffect(() => {
    let newList = [];
    if (!!externalList) {
      for (let value of externalCodeList) {
        for (let listItem of externalList) {
          if (value['value'] === listItem) {
            newList.push(value);
            break;
          }
        }
      }
      setList(newList);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (type === 'select') {
      setList(addAllList([...externalCodeList], 'label', 'value', 'all'));
    } else {
      setList([...externalCodeList]);
    } // eslint-disable-next-line
  }, [externalCodeList]);

  return (
    <FilterCollection
      label={t('외부연동')}
      name={name}
      params={params}
      value={params[name]}
      type={type}
      list={list}
      callBack={handleGetParams}
      labelKey="label"
      valueKey="value"
      popoverWidth={type === 'checkbox' && 500}
    />
  );
};

export default NewExternalFilter;
